export default __webpack_public_path__ + "static/media/DSC04859.14a5bdfd.jpg";